function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Spinner from "../../../shared/Spinner";
export default {
	components: { Spinner: Spinner },
	props: {
		resident: Object
	},
	data: function data() {
		return {
			showNotes: false,
			isLoading: false,
			modalName: "notice-to-vacate",
			noticeEvent: {
				residentId: null,
				moveout_reason_id: null,
				notify_date: moment().format("MM/DD/YYYY"),
				estimated_moveout_date: "",
				address_one: "",
				address_two: "",
				city: "",
				state: "",
				zip: "",
				pro_rate_transactions: [],
				relet_fee: 0,
				note: '',
				resident: {}
			},
			terminationType: "moveout",
			addForwarding: false,
			addCharge: false,
			step: 1,
			maxStep: 2,
			prorate: false,
			selectedMoveoutReason: null,
			moveoutReasons: [],
			showReletFee: false,
			applyProrates: false,
			recurringCharges: [],
			oneTimeCharges: [],
			accountingChargeCodes: [],
			newTransaction: {
				chargeCode: null,
				amount: null,
				chargeType: 'charge'
			},
			currentRentAmount: 0,
			relet_settings: {
				reletting_charge_percent: .85,
				addendum_rent_fee_percent_to_recurring: false
			},
			helper: '',
			today: null,
			stepOneValidations: [{ model: 'noticeEvent.notify_date', rules: 'required | date | before_or_equal:today' }, { model: 'noticeEvent.estimated_moveout_date', rules: 'required | date | after_or_equal:noticeEvent.notify_date' }, { model: 'noticeEvent.relet_fee', rules: 'required_if:showReletFee | integer | min:0' }, { model: 'noticeEvent.note', rules: 'required_if:showNotes' }],
			newTransactionValidations: [{ model: 'newTransaction.amount', rules: 'required | integer | min:0' }, { model: 'newTransaction.chargeCode', rules: 'required' }, { model: 'newTransaction.chargeType', rules: 'required' }],
			stepTwoValidations: []
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.noticeEvent.residentId = this.resident.id;
		this.today = this.getCurrentDate();
		this.$initValidator();

		Event.$on("notice-to-vacate", function () {
			_this.step = 1;
			_this.getAccountingChargeCodes();
			_this.getMoveoutReasons();
			_this.getPropertyLeaseSettings();
			_this.getRecurringTransactions();
			Event.$emit("open-slide", _this.modalName);
		});

		Event.$on('close-full-modal', function () {
			_this.cancel();
		});
	},

	computed: {
		hasOneTimeCharges: function hasOneTimeCharges() {
			return this.oneTimeCharges.length;
		},
		stepIsTwo: function stepIsTwo() {
			return this.step === 2;
		}
	},
	methods: {
		addNewCharge: function addNewCharge() {
			this.newTransaction = {
				chargeType: 'charge',
				chargeCode: {}
			};
			this.addCharge = true;
		},
		getCurrentDate: function getCurrentDate() {
			var today = new Date();
			return today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear();
		},
		getAmountFromChargeCode: function getAmountFromChargeCode(chargeCode) {
			if (chargeCode) {
				this.newTransaction.amount = chargeCode.amount;
			}
		},
		cancel: function cancel() {
			Object.assign(this.$data, this.$options.data());
			this.today = this.getCurrentDate();
			this.$initValidator();
			Event.$emit("close-slide", this.modalName);
		},
		goToNextStep: function goToNextStep() {
			this.validator.setRules(this.stepOneValidations).setCustomMessages({
				'noticeEvent.estimated_moveout_date.after_or_equal': 'This date must be after or equal to the Notification Date.'
			}).validate();

			if (this.validator.passes()) {
				this.step++;
			}
		},
		addNotice: function addNotice() {
			var _this2 = this;

			this.noticeEvent.residentId = this.resident.id;
			this.noticeEvent.notify_type = this.terminationType;
			this.newTransaction.amount = 0;
			this.noticeEvent.address_one = this.resident.address_one;
			this.noticeEvent.address_two = this.resident.address_two;
			this.noticeEvent.city = this.resident.city;
			this.noticeEvent.state = this.resident.state;
			this.noticeEvent.zip = this.resident.zip;

			//create the step2 validation rules based on the recurringCharges array.
			this.recurringCharges.map(function (charge, key) {
				var model = 'recurringCharges.' + key + '.amount';
				_this2.stepTwoValidations.push({ model: model, rules: 'required | integer | min:0' });
			});

			this.validator.setRules(this.stepTwoValidations).validate();

			if (this.validator.fails()) {
				return;
			}
			this.isLoading = true;
			var charges = [].concat(_toConsumableArray(this.oneTimeCharges), _toConsumableArray(this.recurringCharges));

			charges.map(function (charge) {
				if (charge.is_prorated && charge.amount > 0) {
					_this2.noticeEvent.pro_rate_transactions.push(charge);
				}
			});

			axios.post("/prototype/person/residents/notice-events", this.noticeEvent).then(function (response) {
				_this2.isLoading = false;
				if (response.data.error) {
					_this2.$snotify.error("Error saving Notice Event: " + response.data.error);
				} else {
					_this2.$snotify.success("Notice Event saved successfully.");
					Event.$emit("close-slide", _this2.modalName);
					Event.$emit('refresh-resident-dashboard', _this2.resident);
					Event.$emit('reset-tabs');
					Event.$emit('resident-list-dashboard-updated');
				}
				_this2.newTransaction.amount = '';
			});
		},
		getAccountingChargeCodes: function getAccountingChargeCodes() {
			var _this3 = this;

			this.accountingChargeCodes = [];
			axios.post("/prototype/accounting/charge-codes/list").then(function (response) {
				_this3.noticeEvent.pro_rate_transactions = [];
				if (response.data.error) {
					_this3.$snotify.error("Error pulling accounting charge code: " + response.data.error);
				} else {
					response.data.forEach(function (item) {
						_this3.accountingChargeCodes.push({
							label: item.name,
							value: item.id,
							amount: item.amount === '0.00' ? '' : item.amount
						});
					});
				}
			});
		},
		getMoveoutReasons: function getMoveoutReasons() {
			var _this4 = this;

			this.moveoutReasons = [];
			axios.get("/api/moveOutReasons").then(function (response) {
				if (response.data.error) {
					_this4.$snotify.error("Error pulling move out reasons: " + response.data.error);
				} else {
					response.data.forEach(function (item) {
						_this4.moveoutReasons.push({
							label: item.name,
							value: item.id
						});
					});
				}
			});
		},
		getPropertyLeaseSettings: function getPropertyLeaseSettings() {
			var _this5 = this;

			axios.get("/prototype/property/lease-settings").then(function (response) {
				if (response.data.error) {
					_this5.$snotify.error("Error pulling lease settings: " + response.data.error);
				}

				_this5.relet_settings = response.data;

				if (typeof response.data.reletting_charge_percent === "undefined") {
					_this5.relet_settings.reletting_charge_percent = .85;
				}
				if (typeof response.data.addendum_rent_fee_percent_to_recurring === "undefined") {
					_this5.relet_settings.addendum_rent_fee_percent_to_recurring = false;
				}
			});
		},
		getRecurringTransactions: function getRecurringTransactions() {
			var _this6 = this;

			this.recurringCharges = [];
			axios.post("/prototype/accounting/accounts-receivable/transactions/resident/recurring", {
				id: this.resident.id,
				type: 'current'
			}).then(function (response) {
				if (response.data.error) {
					_this6.$snotify.error("Error pulling recurring transactions: " + response.data.error);
				} else {
					response.data.forEach(function (item) {
						_this6.recurringCharges.push({
							ar_transaction_recurring_id: item.id,
							chargeCodeId: item.code.id,
							chargeType: item.is_credit ? 'credit' : 'charge',
							is_debit: item.is_debit,
							name: item.code.name,
							original_amount: item.true_amount,
							is_prorated: item.code.name.toLowerCase().includes('insurance') ? false : true,
							is_new_charge: false,
							amount: null,
							prorated_amount: null
						});
					});
				}
			});
		},
		addNewTransaction: function addNewTransaction() {
			this.validator.setRules(this.newTransactionValidations).validate();

			if (this.validator.passes()) {
				this.oneTimeCharges.push({
					ar_transaction_recurring_id: null,
					chargeCodeId: this.newTransaction.chargeCode.value,
					chargeType: this.newTransaction.chargeType,
					name: this.newTransaction.chargeCode.label,
					original_amount: this.newTransaction.amount,
					is_prorated: true,
					is_new_charge: true,
					amount: this.newTransaction.amount
				});

				this.newTransaction = { chargeType: 'charge',
					chargeCode: {} };
				this.addCharge = false;
			}
		},
		calculateProrateAmount: function calculateProrateAmount(price) {
			var estimated_moveout_date = moment(this.noticeEvent.estimated_moveout_date, 'MM/DD/YYYY');

			var startOfMonth = estimated_moveout_date.clone();
			startOfMonth = moment(startOfMonth).startOf('month').format('YYYY-MM-DD');

			var days = estimated_moveout_date.diff(startOfMonth, 'days') + 1;
			var daysInMonth = estimated_moveout_date.daysInMonth();
			return (price / daysInMonth * days).toFixed(2);
		},
		calculateProrates: function calculateProrates() {
			var _this7 = this;

			this.recurringCharges.map(function (charge) {
				charge.prorated_amount = _this7.calculateProrateAmount(charge.original_amount);
				charge.amount = charge.is_prorated ? charge.prorated_amount : charge.original_amount;
			});
		},
		updateNoticeEventMoveOutReasonId: function updateNoticeEventMoveOutReasonId(selectedVal) {
			this.noticeEvent.moveout_reason_id = selectedVal ? selectedVal.value : null;
		},
		updateChargeAmount: function updateChargeAmount(index, checked) {
			this.recurringCharges[index].amount = checked ? this.recurringCharges[index].prorated_amount : this.recurringCharges[index].original_amount;
		}
	},
	watch: {
		showReletFee: function showReletFee() {
			// Relet fee is based on a couple of property lease settings:
			// 1) addendum_rent_fee_percent_to_recurring - take from recurring transaction, or lease actual_rent_amount?
			// 2) reletting_charge_percent - defaults to 85%, but can be set per property
			this.noticeEvent.relet_fee = 0;
			if (Object.keys(this.relet_settings).length === 0 || this.relet_settings.reletting_charge_percent === 0) {
				this.relet_settings.reletting_charge_percent = .85;
			}
			if (this.showReletFee) {
				if (this.relet_settings.addendum_rent_fee_percent_to_recurring) {
					var rentRCObject = this.recurringCharges.find(function (charge) {
						return charge.name.toLowerCase() === 'rent';
					});
					if (rentRCObject) {
						this.currentRentAmount = rentRCObject.original_amount;
						this.noticeEvent.relet_fee = (rentRCObject.original_amount * this.relet_settings.reletting_charge_percent).toFixed(2);
					}
				} else {
					this.currentRentAmount = this.resident.lease.actual_rent_amount;
					this.noticeEvent.relet_fee = (this.resident.lease.actual_rent_amount * this.relet_settings.reletting_charge_percent).toFixed(2);
				}

				if (this.noticeEvent.relet_fee === 'NaN' && typeof this.noticeEvent.relet_fee === 'string') this.noticeEvent.relet_fee = 0;
				this.showNotes = false;
			} else {
				if (this.terminationType === 'skip' || this.terminationType === 'eviction') {
					this.showNotes = true;
				}
				this.noticeEvent.relet_fee = 0;
			}
		},
		step: function step() {
			if (this.step === 2) {
				this.calculateProrates();
			}
		},
		terminationType: function terminationType() {
			this.showReletFee = false;
			this.showNotes = false;

			if (this.terminationType === 'skip') {
				this.showReletFee = true;
				this.showNotes = !this.showReletFee;
			}

			var _label = void 0;
			switch (this.terminationType) {
				case 'skip':
					_label = 'Skipped';
					break;
				case 'eviction':
					_label = 'Eviction';
					break;
				default:
					_label = null;
					break;
			}

			if (_label) {
				var _value = this.moveoutReasons.findIndex(function (r) {
					return r.label.toLowerCase() === _label.toLowerCase();
				});
				if (_value > 0) {
					var _payload = {
						value: this.moveoutReasons[_value].value,
						label: _label
					};

					this.selectedMoveoutReason = _payload;
					this.updateNoticeEventMoveOutReasonId(_payload);
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/new-resident-details/move-outs/NoticeToVacate.vue
// module id = OEAO
// module chunks = 0 1